module.exports = new __parcel__URL__("secure-tunnel.6ac8e6a7.png").toString();